import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class VTSHistoryService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetVTSHistoryList(input?: DataListModel, vehicleMasterHashId?: string): Observable<IAPIResponse> {
    let getVTSHistoryUrl = WeGoConfig.API_GET_VTS_HISTORY_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getVTSHistoryUrl = getVTSHistoryUrl + "?" + queryString + "&vehicleMasterHashId=" + vehicleMasterHashId;
      //getVTSHistoryUrl = getVTSHistoryUrl + "?" + queryString + "&vehicleMasterHashId=" + "_Bx9u3eZsUw%24";
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getVTSHistoryUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportVTSHistoryList(input?: DataListModel,vehicleMasterHashId?: string): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getVTSHistoryUrl = WeGoConfig.API_EXPORT_VTS_HISTORY_LIST + "?" + queryString + "&vehicleMasterHashId=" + vehicleMasterHashId;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getVTSHistoryUrl, options);
  }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vtshistory/models/vtshistory.service.ts